import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
// import organizationReducer from './slices/organizations';
import userReducer from './slices/user';
import workspaceReducer from './slices/workspace';
// import deviceReducer from './slices/device';
// import notificationReducer from './slices/notifications';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

/* const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
}; */

const rootReducer = combineReducers({
  // organization: organizationReducer,
  user: userReducer,
  workspace: workspaceReducer
  // device: deviceReducer,
  // notification: notificationReducer
  // product: persistReducer(productPersistConfig, productReducer)
});

export { rootPersistConfig, rootReducer };
